module.exports = __webpack_public_path__ + "static/media/fondo-home-paquetes.ab466eba.webp";